import { Controller } from "@hotwired/stimulus"

// /instalar: shows the one-tap install button when the browser offers it
// (Chrome/Edge on Android and desktop) and says so when Veci already runs
// as an installed app. The manual steps stay visible for every browser.
export default class extends Controller {
  static targets = ["button", "installed"]

  connect() {
    this.refresh = this.refresh.bind(this)
    document.addEventListener("veci:installable", this.refresh)
    window.addEventListener("appinstalled", this.refresh)
    this.refresh()
  }

  disconnect() {
    document.removeEventListener("veci:installable", this.refresh)
    window.removeEventListener("appinstalled", this.refresh)
  }

  refresh() {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true
    this.installedTarget.hidden = !standalone
    this.buttonTarget.hidden = standalone || !window.veciInstallPrompt
  }

  async install() {
    const prompt = window.veciInstallPrompt
    if (!prompt) return

    prompt.prompt()
    await prompt.userChoice
    window.veciInstallPrompt = null
    this.refresh()
  }
}
